// extracted by css-extract-rspack-plugin
export default {"cls1":"LanguageRow-cls1_bhw","cls2":"LanguageRow-cls2_mGq LanguageRow-cls1_bhw"};